module.exports = __webpack_public_path__ + "static/billboardslider-05-min-7be1e8caf6dea98c6af23c1689c427df.jpg";